import ButtonRow, { Button } from "../components/ButtonRow";
import { Col, Row } from "../components/Grid";
import Hero, { HeroText } from "../components/Hero";

import ContentBlock from "../components/ContentBlock";
import HtmlContainer from "../components/HtmlContainer";
import Image from "../components/Image";
import PropTypes from "prop-types";
import React from "react";
import TextSection from "../components/TextSection";
import Video from "../components/Video";
import govButtons from "../content/Home-GovButtons";
import injectSheet from "react-jss";
import voterButtons from "../content/Home-VoterButtons";
import HeroImg from "../img/Hero-home.jpg";
import MapHome from "../img/Map-home.png";

const styles = theme => ({
  greenButton: {
    backgroundColor: theme.colours.products.mp
  },
  purpleButton: {
    backgroundColor: theme.colours.products.scot
  },
  orangeButton: {
    backgroundColor: theme.colours.products.mla
  },
  blueButton: {
    backgroundColor: theme.colours.palette.blue
  },
  redButton: {
    backgroundColor: theme.colours.products.td
  },
  yellowButton: {
    backgroundColor: theme.colours.palette.yellow
  },
  pinkButton: {
    backgroundColor: theme.colours.palette.pink
  },
  whiteContent: {
    backgroundColor: theme.colours.palette.white,
    minHeight: "40vh"
  },
  textBox: {
    maxWidth: "35vw",
    "& h1": {
      fontSize: "3.6rem",
      textAlign: "center",
      fontWeight: 100,
      margin: 0,
      "@media (max-width: 823px)": {
        fontSize: "2.2rem"
      }
    },
    "@media (max-width: 823px)": {
      fontSize: "1rem",
      maxWidth: "75vw"
    }
  },
  contentBox: {
    minHeight: "40vh"
  },
  container: {
    width: "100%"
  },
  noMobile: {
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  mobile: {
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  video: {
    "@media (max-width: 823px)": {
      display: "none"
    },
    // iPad portrait mode
    "@media (min-width: 824px) and (max-width: 1400px)": {
      width: "400px",
      height: "225px"
    }
  },
  mobileVideo: {
    marginTop: "2rem",
    width: "90vw",
    height: "50vw",
    // Phone landscape
    "@media (orientation: landscape)": {
      width: "160vh",
      height: "90vh"
    },
    "@media (min-width: 767px) and (max-width: 769px)": {
      height: "30vh"
    },
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  voterImage: {
    width: "450px",
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  voterMobileImage: {
    marginTop: "2rem",
    width: "300px",
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  logo: {
    height: "29vh",
    maxHeight: "400px"
  },
  heroText: {
    topMargin: "1.5rem"
  }
});

const HomePage = ({ data, classes }) => (
  <div className={classes.page}>
    <Hero hero={HeroImg}>
      <Row center top>
        <HeroText>
          <HtmlContainer
            className={classes.heroText}
            content={data.HeroText.html}
          />
          <img src="/EtechLogo_NoText.png" className={classes.logo} />
        </HeroText>
      </Row>
    </Hero>
    <ContentBlock className={classes.contentBox} id="features">
      <div className={classes.container}>
        <div className={classes.noMobile}>
          <Row around middle>
            <Video
              name="Caseworker.mp Video"
              className={classes.video}
              src="//www.youtube.com/embed/tKMXw7BJhck?rel=0&amp;showinfo=0"
            />
            <Col middle center>
              <TextSection className={classes.textBox}>
                <HtmlContainer content={data.FirstContentSection.html} />
              </TextSection>
              <ButtonRow>
                <Button
                  className={classes.greenButton}
                  linkUrl="/mp"
                  label="MP"
                />
                <Button
                  className={classes.purpleButton}
                  linkUrl="/scot"
                  label="MSP"
                />
                <Button
                  className={classes.orangeButton}
                  linkUrl="/mla"
                  label="MLA"
                />
                <Button
                  className={classes.blueButton}
                  linkUrl="/mp"
                  label="AM"
                />
                <Button
                  className={classes.redButton}
                  linkUrl="/td"
                  label="TD"
                />
                <Button
                  className={classes.yellowButton}
                  linkUrl="/mp"
                  label="MEP"
                />
              </ButtonRow>
              <Video
                name="Caseworker.mp Video"
                className={classes.mobileVideo}
                src="//www.youtube.com/embed/tKMXw7BJhck?rel=0&amp;showinfo=0"
              />
            </Col>
          </Row>
        </div>
        <div className={classes.mobile}>
          <Col middle center>
            <TextSection className={classes.textBox}>
              <HtmlContainer content={data.FirstContentSection.html} />
            </TextSection>
            <ButtonRow>
              <Button
                className={classes.greenButton}
                linkUrl="/mp"
                label="MP"
              />
              <Button
                className={classes.purpleButton}
                linkUrl="/scot"
                label="MSP"
              />
              <Button
                className={classes.orangeButton}
                linkUrl="/mla"
                label="MLA"
              />
              <Button className={classes.blueButton} linkUrl="/mp" label="AM" />
              <Button className={classes.redButton} linkUrl="/td" label="TD" />
              <Button
                className={classes.yellowButton}
                linkUrl="/mp"
                label="MEP"
              />
            </ButtonRow>
            <Video
              name="Caseworker.mp Video"
              className={classes.mobileVideo}
              src="//www.youtube.com/embed/tKMXw7BJhck?rel=0&amp;showinfo=0"
            />
          </Col>
        </div>
      </div>
    </ContentBlock>
    <ContentBlock className={classes.whiteContent}>
      <div className={classes.container}>
        <div className={classes.noMobile}>
          <Row around middle>
            <Col middle center>
              <TextSection className={classes.textBox}>
                <HtmlContainer content={data.SecondContentSection.html} />
              </TextSection>
              <ButtonRow>
                {govButtons.map(button => (
                  <Button
                    className={classes.pinkButton}
                    linkUrl="/gov"
                    label={button}
                    key={button}
                  />
                ))}
              </ButtonRow>
            </Col>
            <Video
              name="Caseworker.gov Video"
              className={classes.video}
              src="//www.youtube.com/embed/0y_gRbWLuSM?rel=0&amp;showinfo=0"
            />
          </Row>
        </div>
        <div className={classes.mobile}>
          <Col middle center>
            <TextSection className={classes.textBox}>
              <HtmlContainer content={data.SecondContentSection.html} />
            </TextSection>
            <ButtonRow>
              {govButtons.map(button => (
                <Button
                  className={classes.pinkButton}
                  linkUrl="/gov"
                  label={button}
                  key={button}
                />
              ))}
            </ButtonRow>
            <Video
              name="Caseworker.gov Video"
              className={classes.mobileVideo}
              width="100%"
              height="150%"
              src="//www.youtube.com/embed/0y_gRbWLuSM?rel=0&amp;showinfo=0"
            />
          </Col>
        </div>
      </div>
    </ContentBlock>
    <ContentBlock className={classes.contentBox}>
      <div className={classes.container}>
        <Row around>
          <Video
            name="Caseworker.gov Video"
            className={classes.video}
            width="100%"
            height="150%"
            src="//www.youtube.com/embed/G6lXdrwwAIg?rel=0&amp;showinfo=0"
          />
          <Col bottom center>
            <TextSection className={classes.textBox}>
              <HtmlContainer content={data.ThirdContentSection.html} />
            </TextSection>
            <ButtonRow>
              {voterButtons.map(button => (
                <Button
                  className={classes.yellowButton}
                  linkUrl="/voter"
                  label={button}
                  key={button}
                />
              ))}
            </ButtonRow>
            <Video
              name="Caseworker.gov Video"
              className={classes.mobileVideo}
              width="100%"
              height="150%"
              src="//www.youtube.com/embed/G6lXdrwwAIg?rel=0&amp;showinfo=0"
            />
          </Col>
        </Row>
      </div>
    </ContentBlock>
  </div>
);

HomePage.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
  route: PropTypes.object
};

export default injectSheet(styles)(HomePage);

/* global graphql */
export const HomeQuery = graphql`
  query HomeQuery {
    HeroText: markdownRemark(frontmatter: { name: { eq: "Home-HeroText" } }) {
      html
      frontmatter {
        name
      }
    }
    FirstContentSection: markdownRemark(
      frontmatter: { name: { eq: "Home-TopSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentSection: markdownRemark(
      frontmatter: { name: { eq: "Home-MidSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    ThirdContentSection: markdownRemark(
      frontmatter: { name: { eq: "Home-BottomSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx